import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Loadable from '@axiomhq/react-loadable';

export const PAGES = {
  LOGIN: 'login',
  HOME: 'home',
  BLANK: 'blank',
  INFO_SALDO: 'infosaldo',
};
export const SIDE_LINK = [
  {
    to: '/',
    name: 'Dashboard',
    icon: FontAwesomeIcon,
    iconName: 'th-large',
    page: '',
  },
  {
    to: '/data-siswa',
    name: 'Data Siswa',
    icon: FontAwesomeIcon,
    iconName: 'users',
    page: 'data-siswa',
  },
  {
    to: '/kelas-tahunajaran',
    name: 'Kelas | Tahun Ajaran',
    icon: FontAwesomeIcon,
    iconName: 'list-alt',
    page: 'kelas-tahunajaran',
  },
  {
    to: '/kategori',
    name: 'Kategori',
    icon: FontAwesomeIcon,
    iconName: 'list-alt',
    page: 'kategori',
  },
  {
    to: '/menutagihan',
    name: 'Menu Tagihan',
    icon: FontAwesomeIcon,
    iconName: 'list-alt',
    page: 'menutagihan',
  },
  {
    to: '/tagihan-siswa',
    name: 'Tagihan Siswa',
    icon: FontAwesomeIcon,
    iconName: 'money-check-alt',
    page: 'tagihan-siswa',
  },
  {
    to: '/pembayaran',
    name: 'Pembayaran',
    icon: FontAwesomeIcon,
    iconName: 'money-check-alt',
    page: 'pembayaran',
  },
  {
    to: '/tabungan',
    name: 'Tabungan',
    icon: FontAwesomeIcon,
    iconName: 'piggy-bank',
    page: 'tabungan',
  },
  {
    to: '/laporan',
    name: 'Laporan',
    icon: FontAwesomeIcon,
    iconName: 'file-invoice-dollar',
    page: 'laporan',
  },
  {
    to: '/admin',
    name: 'Admin',
    icon: FontAwesomeIcon,
    iconName: 'user-cog',
    page: 'admin',
  },
];

const Loading = () => null;
const Dashboard = Loadable({
  loader: () => import('./components/dashboard'),
  loading: Loading,
});

const Login = Loadable({
  loader: () => import('./components/auth'),
  loading: Loading,
});

const Students = Loadable({
  loader: () => import('./components/students'),
  loading: Loading,
});
const DetailStudent = Loadable({
  loader: () => import('./components/students/DetailStudent'),
  loading: Loading,
});
const Transactions = Loadable({
  loader: () => import('./components/transactions'),
  loading: Loading,
});
const Category = Loadable({
  loader: () => import('./components/category'),
  loading: Loading,
});
const StudentBill = Loadable({
  loader: () => import('./components/TagihanSiswa'),
  loading: Loading,
});
const Kelas = Loadable({
  loader: () => import('./components/kelas'),
  loading: Loading,
});
const MenuTagihan = Loadable({
  loader: () => import('./components/menutagihan'),
  loading: Loading,
});
const Tabungan = Loadable({
  loader: () => import('./components/tabungan'),
  loading: Loading,
});
const Admin = Loadable({
  loader: () => import('./components/admin/admin'),
  loading: Loading,
});
const Laporan = Loadable({
  loader: () => import('./components/laporan'),
  loading: Loading,
});
const CetakInvoice = Loadable({
  loader: () => import('./components/transactions/CetakInvoice'),
  loading: Loading,
});
const CetakInvoiceSekolah = Loadable({
  loader: () => import('./components/transactions/CetakInvoiceSekolah'),
  loading: Loading,
});
const CardDetailTransaksi = Loadable({
  loader: () => import('./components/transactions/CardDetailTransaksi'),
  loading: Loading,
});

export const route = [
  {
    path: '/',
    component: Dashboard,
    exact: true,
  },
  {
    path: '/data-siswa/',
    component: Students,
    exact: true,
  },
  {
    path: '/data-siswa/siswa/:id',
    component: DetailStudent,
  },
  {
    path: '/kelas-tahunajaran/',
    component: Kelas,
  },
  {
    path: '/menutagihan/',
    component: MenuTagihan,
  },
  {
    path: '/kategori/',
    component: Category,
  },
  {
    path: '/pembayaran/',
    component: Transactions,
  },
  {
    path: '/tabungan/',
    component: Tabungan,
  },
  {
    path: '/tagihan-siswa/',
    component: StudentBill,
    exact: true,
  },
  {
    path: '/tagihan-siswa/spp',
    component: StudentBill,
  },
  {
    path: '/tagihan-siswa/gedung',
    component: StudentBill,
  },
  {
    path: '/laporan/',
    component: Laporan,
  },
  {
    path: '/login/',
    component: Login,
  },
  {
    path: '/transaksi-siswa',
    component: CetakInvoice,
  },
  {
    path: '/pembayaran-detail/:id',
    component: CardDetailTransaksi,
  },
  {
    path: '/transaksi-sekolah',
    component: CetakInvoiceSekolah,
  },
  {
    path: '/admin/',
    component: Admin,
  },
];
